import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CricketRanking from '../CricketRanking/CricketRanking';
import s from './CricketStats.scss';
import Link from '../../../../../components/Link/Link';
import Image from '../../../../../components/Image';
import CricketStatsCard from './CricketStatsCard';
import { TOI_IMAGE_DOMAIN } from '../../../../../constants';

import {
  groupData,
  statsValueMapCategory,
  statsTableHeaderMap,
} from './CricketStatsUtils';

const CricketStatsWrapper = props => {
  let TEAM_TEXT = 'Batting';
  const { cricketStats = [], default_url = '', StatID = '', tournamentName } =
    props.sectionItem || {};
  const { seo } = props;
  const thumbslist =
    cricketStats && cricketStats.playerthumbs && cricketStats.playerthumbs.data;
  const defaultThumb = `${TOI_IMAGE_DOMAIN}/thumb/msid-81945120,width-50,height-100/81945120.jpg`;
  TEAM_TEXT = StatID && statsValueMapCategory[StatID];
  const [activeGroupTab, setActiveGroupTab] = useState(TEAM_TEXT);
  const [cricketStatsData, setCricketStatsData] = useState(
    cricketStats[TEAM_TEXT],
  );
  const onGroupTabsChange = dataObj => {
    if (dataObj && dataObj?.link && default_url) {
      setActiveGroupTab(dataObj?.link);
    }
  };
  useEffect(
    () => {
      if (
        cricketStats &&
        cricketStats[activeGroupTab] &&
        Array.isArray(cricketStats[activeGroupTab]) &&
        cricketStats[activeGroupTab].length > 0
      ) {
        setCricketStatsData(cricketStats[activeGroupTab]);
      }
    },
    [activeGroupTab],
  );

  let tableData =
    cricketStatsData &&
    Array.isArray(cricketStatsData) &&
    cricketStatsData.length > 0 &&
    cricketStatsData.filter(
      statsData =>
        StatID &&
        (statsData.stat_id === StatID || statsData.stat_id === +StatID),
    );
  tableData = tableData && tableData.length > 0 && tableData[0];
  if (!tableData) {
    tableData =
      cricketStatsData &&
      Array.isArray(cricketStatsData) &&
      cricketStatsData.length > 0 &&
      cricketStatsData[0];
  }
  const tableHeader = statsTableHeaderMap[tableData.stat_id];
  const tableHeaderMapHead = tableHeader;

  const tablevalueMap = Object.keys(tableHeader);

  return (
    <>
      <div className={`${s.stats_page_cont} ${s.stats_page_wrapper}`}>
        {seo?.h1 && <h1 className={s.h1tag}>{seo?.h1}</h1>}
        {groupData &&
          Array.isArray(groupData) &&
          groupData.length > 0 && (
            <CricketRanking
              groupData={groupData}
              onGroupTabsChange={onGroupTabsChange}
              cricketRanking=""
              currentTab={TEAM_TEXT}
              hideTabs=""
            />
          )}
        {tableData && (
          <div
            className={`${s.stats_table} ${
              tournamentName === 'ipl' ? 'pointsTableLeague ' : ''
            }
        `}
          >
            <div className={`${s.top_header}`}>
              <div className={s.top_header_bg} />
              {tableData?.display_name}
            </div>
            {tableData.leaderboard &&
              Array.isArray(tableData.leaderboard) &&
              tableData.leaderboard.length > 0 && (
                <ul className={`${s.list} ${s.listActive}`}>
                  <li className={s.head}>
                    {Object.entries(tableHeaderMapHead).map(
                      ([key, header], index) => (
                        <>
                          {header &&
                            index !== 1 && (
                              <span className={`${s[key]}`}>{header}</span>
                            )}
                          {header &&
                            index === 1 && (
                              <span className={`${s.span_fix} ${s[key]}`}>
                                {header}
                              </span>
                            )}
                          {!header &&
                            index === 0 && (
                              <span className={`${s.player_image} ${s[key]}`}>
                                {header}
                              </span>
                            )}
                        </>
                      ),
                    )}
                  </li>
                  {tableData.leaderboard.slice(0, 10).map((item, index) => (
                    <li className={s.selected} key={index}>
                      {tablevalueMap.map(header => {
                        let playerkey = item && item.player_name;
                        playerkey =
                          (playerkey &&
                            playerkey
                              .split(' ')
                              .join('-')
                              .toUpperCase()) ||
                          null;
                        return (
                          <>
                            {header === 'player_pic' && (
                              <span className={s.player_image}>
                                <Link
                                  to={`https://timesofindia.indiatimes.com/topic/${playerkey}`}
                                >
                                  {thumbslist &&
                                  thumbslist[playerkey] &&
                                  thumbslist[playerkey].strimg ? (
                                    <Image
                                      key={thumbslist[playerkey].playernameseo}
                                      src={thumbslist[playerkey].strimg}
                                      placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/42706777.gif`}
                                      alt={thumbslist[playerkey].playernameseo}
                                      lazyload
                                      offsetVertical={200}
                                    />
                                  ) : (
                                    <Image
                                      key="default_1"
                                      src={defaultThumb}
                                      placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/42706777.gif`}
                                      alt="default"
                                      lazyload
                                      offsetVertical={200}
                                    />
                                  )}
                                </Link>
                              </span>
                            )}
                            {(header === 'player_name' ||
                              header === 'team_short_name') && (
                              <>
                                {header === 'player_name' && (
                                  <span
                                    className={`${s.name_country} ${
                                      s.span_fix
                                    } ${s[header]}`}
                                  >
                                    {item[header]}
                                    {item.team_short_name && (
                                      <span
                                        className={`${s.countryname} ${
                                          s[header]
                                        }`}
                                      >
                                        <span
                                          className={`${s.teamFlag} ${
                                            s[item.team_short_name]
                                          }`}
                                        />{' '}
                                        {item.team_short_name}
                                      </span>
                                    )}
                                  </span>
                                )}
                              </>
                            )}
                            {header !== 'team_short_name' &&
                              header !== 'player_name' &&
                              header !== 'player_pic' && (
                                <span className={`${s[header]}`}>
                                  {item[header]}
                                </span>
                              )}
                          </>
                        );
                      })}
                    </li>
                  ))}
                </ul>
              )}
          </div>
        )}
        <div className={s.stats_container}>
          {cricketStatsData &&
            Array.isArray(cricketStatsData) &&
            cricketStatsData.length > 0 && (
              <CricketStatsCard
                cricketStatsData={cricketStatsData}
                tournamentName={tournamentName}
              />
            )}
        </div>
      </div>
    </>
  );
};
CricketStatsWrapper.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  //deviceType: PropTypes.string,
};
CricketStatsWrapper.defaultProps = {
  sectionItem: {},
  //deviceType: '',
};
export default CricketStatsWrapper;
